import { getResult, getUrlQueryInfo } from "../services.utils";
import { ChatbotService } from "./chatbot.service";
import { ChatbotHistory, ChatbotPromptInfo } from "../../../shared/models/chatbot-history.model";
import { MetadataRequest } from "../../../shared/models/metadata-request.model";

/***
 * This is the standard backend implementation that uses the API server to get data.
 */
export class ChatbotServiceImpl implements ChatbotService {
    appAPIUrl: string;
    showSnackbar: (message: string, severity: string) => void;

    constructor(appAPIUrl: string, showSnackbar: (message: string, severity: string) => void) {
        this.appAPIUrl = appAPIUrl;
        this.showSnackbar = showSnackbar;
    }

    public getContinuation = async (
        site: string,
        history: ChatbotHistory,
        question: string,
        org: string | null,
        cfg: string | null,
        request: MetadataRequest,
    ): Promise<ChatbotPromptInfo> => {
        const res = await fetch(`${this.appAPIUrl}/chatbot/${site}${getUrlQueryInfo(org, cfg, request)}`,
            {
                method: "POST",
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    history: history,
                    question: question,
                }),
            });
        return getResult(res, false, this.showSnackbar);
    }

}
